module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/Next-ac052a84a61e33d5c943852ddc2f0b04.svg";